module.exports = __webpack_public_path__ + "static/media/image (26).a6901edd.jpg";